import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  getPayPalMerchantAccounts,
  IndividualPayPalMerchantAccount,
} from 'api/admin/businesses/getPayPalMerchantAccounts';

export const PAYPAL_MERCHANT_ACCOUNTS_QUERY_KEY = 'getPayPalMerchantAccounts';

export const usePayPalMerchantAccounts = (businessId: number) => {
  const {
    isLoading,
    error,
    data = [],
    refetch,
  } = useQuery<unknown, AxiosError<{ error: string }>, IndividualPayPalMerchantAccount[]>({
    queryKey: [PAYPAL_MERCHANT_ACCOUNTS_QUERY_KEY, businessId],
    queryFn: async () => {
      const response = await getPayPalMerchantAccounts(businessId);
      return response.data?.merchantAccounts ?? [];
    },
    enabled: !!businessId,
    retry: 1,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching PayPal merchant accounts',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
